import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { closeAlert } from './AlertActions';
import AlertVariant from './AlertVariant';

function AlertContainer({ position: customPosition, dismissable = true }) {
  const dispatch = useDispatch();

  const {
    open,
    text,
    variant = AlertVariant.PRIMARY,
    isMarkup,
    onClickAction,
    position,
  } = useSelector((state) => ({
    text: state.alert.get('text'),
    variant: state.alert.get('variant'),
    open: state.alert.get('show'),
    isMarkup: state.alert.get('isMarkup'),
    onClickAction: state.alert.get('onClickAction'),
    position: state.alert.get('position'),
  }));

  const alertPosition = customPosition || position || 'bottom-left';

  const createMarkup = () => ({ __html: text });

  const checkTypeOfText = () => {
    if (typeof text === 'object') {
      return text?.message;
    }
    return text;
  };

  const getPositionClassName = () => {
    if (alertPosition === 'custom') {
      return 'alert-container alert-container-custom';
    }
    return `alert-container alert-container-${alertPosition}`;
  };

  const getToggleHandler = () => (dismissable ? () => dispatch(closeAlert()) : undefined);

  const shouldShowAlert =
    (customPosition && position === 'custom') || (!customPosition && position !== 'custom');

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {text && shouldShowAlert && (
        <Alert
          isOpen={open}
          color={variant}
          className={getPositionClassName()}
          toggle={getToggleHandler()}
          onClick={onClickAction}
        >
          {isMarkup ? (
            <div
              className="d-flex align-items-center"
              dangerouslySetInnerHTML={createMarkup()}
            />
          ) : (
            checkTypeOfText()
          )}
        </Alert>
      )}
    </>
  );
}

AlertContainer.propTypes = {
  position: PropTypes.string,
  dismissable: PropTypes.bool,
};

AlertContainer.defaultProps = {
  position: 'bottom-left',
  dismissable: true,
};

export default AlertContainer;
